/**
 * @desc        Chemical Records
 * @version     1.1 - 1 Feb 22 **/

import * as actionTypes from '../../actions/action-types.js'

const initialState = {
    lastFetch: 0,
    loading: false,
}

const sensor = (state = initialState, action) => {
    const { data, type } = action || {}
    switch (type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_SEN_REQUEST_SUCCESS:
            return {
                ...state,
                loading: false,
                lastFetch: Date.now(),
                data: data,
            }
        case actionTypes.FD_SEN_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.FD_SEN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_SEN_CACHE:
            return state
        default: {
            return state
        }
    }
}

export default sensor
